import React from 'react'
import { PieChart, Pie, Cell, Tooltip } from 'recharts'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import { localized } from 'decorators'
import { DashboardItem, COLORS, formatters } from 'components/dashboard'
import { api } from 'store/modules/dashboard'
import { useStyles } from './index.css'

const createPie = ({ data, cx, cellKey, type }) => {
  return (
    <Pie data={data} cx={cx} cy={80} outerRadius={80} labelLine={false} dataKey='value'>
      {data.map((entry, index) => <Cell key={`${cellKey}-${index}`} type={type} fill={COLORS[index % COLORS.length]} />)}
    </Pie>
  )
}

export const SoldByChannels = localized(({ localize }) => {
  const classes = useStyles()
  const [data, setData] = React.useState(null)
  const handleData = React.useCallback(x => setData(x), [setData])
  const channelName = React.useCallback(x => localize(`enums.soldByChannel_${x.saleChannel}`), [localize])
  const getSoldByChannelsAPI = React.useCallback(() => api.getSoldByChannels(new Date().getFullYear()), [api])
  return (
    <DashboardItem
      title={localize('dashboard.soldByChannels_title')}
      dataSource={getSoldByChannelsAPI}
      bodyClassName={classes.root}
      onDataReceived={handleData}>
      {data && <PieChart width={600} height={170}>
        {createPie({ data: data.map(x => ({ name: channelName(x), value: x.bottles })), cx: 95, cellKey: 'cell-bottles', type: 'bottles' })}
        {createPie({ data: data.map(x => ({ name: channelName(x), value: x.totalAcquisitionPrice })), cx: 295, cellKey: 'cell-acquisition-prices', type: 'prices' })}
        {createPie({ data: data.map(x => ({ name: channelName(x), value: x.totalActualPrice })), cx: 495, cellKey: 'cell-actual-prices', type: 'prices' })}
        <Tooltip formatter={(value, name, props) => formatters(localize)[props.payload.type](value)} />
      </PieChart>}
      {data && <React.Fragment>
          <Table className={classes.table} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>{localize('dashboard.soldByChannels_channel')}</TableCell>
                <TableCell align='right'>{localize('dashboard.soldByChannels_bottles')}</TableCell>
                <TableCell align='right'>{localize('dashboard.soldByChannels_acquisition')}</TableCell>
                <TableCell  align='right'>{localize('dashboard.soldByChannels_actual')}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((x, idx) => <TableRow key={idx}>
                  <TableCell>{channelName(x)}</TableCell>
                  <TableCell align='right'>{formatters(localize).bottles(x.bottles)}</TableCell>
                  <TableCell align='right'>{formatters(localize).prices(x.totalAcquisitionPrice)}</TableCell>
                  <TableCell align='right'>{formatters(localize).prices(x.totalActualPrice)}</TableCell>
                </TableRow>)}
            </TableBody>
          </Table>
        </React.Fragment>}
    </DashboardItem>
  )
})
